export const LOGO_LIGHT_BG =
  'https://customer-assets-v7afamib.emergentagent.net/job_cni-inmobiliaria/artifacts/834b0e974274f5b1_logo%20azul.png';
export const LOGO_DARK_BG =
  'https://customer-assets-v7afamib.emergentagent.net/job_cni-inmobiliaria/artifacts/e95b4608bb300147_logo%20blanco%20%282%29.png';

export const IMAGES = {
  hero: 'https://customer-assets-v7afamib.emergentagent.net/job_cni-inmobiliaria/artifacts/0efefdebd3049002_Panor%C3%A1mica%20urbana%20al%20atardecer.png',
  skylineDusk:
    'https://images.pexels.com/photos/17871020/pexels-photo-17871020.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  ctaBanner:
    'https://images.pexels.com/photos/16960662/pexels-photo-16960662.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  propertyCard:
    'https://images.pexels.com/photos/16110999/pexels-photo-16110999.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  propertyDetail:
    'https://images.pexels.com/photos/27307400/pexels-photo-27307400.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
};

export const NAV_LINKS = [
  { to: '/', label: 'Inicio', testid: 'nav-link-inicio' },
  { to: '/propiedades', label: 'Propiedades', testid: 'nav-link-propiedades' },
  { to: '/mapa', label: 'Mapa', testid: 'nav-link-mapa' },
  { to: '/nosotros', label: 'Nosotros', testid: 'nav-link-nosotros' },
  { to: '/beneficios', label: 'Beneficios', testid: 'nav-link-beneficios' },
  { to: '/membresias', label: 'Membresías', testid: 'nav-link-membresias' },
  { to: '/capacitacion', label: 'Capacitación', testid: 'nav-link-capacitacion' },
  { to: '/noticias', label: 'Noticias', testid: 'nav-link-noticias' },
  { to: '/contacto', label: 'Contacto', testid: 'nav-link-contacto' },
];

export const PROPERTY_TYPES = [
  { value: 'casa', label: 'Casa' },
  { value: 'departamento', label: 'Departamento' },
  { value: 'terreno', label: 'Terreno' },
  { value: 'oficina', label: 'Oficina' },
  { value: 'local', label: 'Local comercial' },
];

export const OPERATIONS = [
  { value: 'venta', label: 'Venta', color: '#F97316' },
  { value: 'alquiler', label: 'Alquiler', color: '#0F4C81' },
  { value: 'anticretico', label: 'Anticrético', color: '#10B981' },
];

export const OPERATION_LABELS = { venta: 'Venta', alquiler: 'Alquiler', anticretico: 'Anticrético' };
export const PROPERTY_TYPE_LABELS = { casa: 'Casa', departamento: 'Departamento', terreno: 'Terreno', oficina: 'Oficina', local: 'Local' };
export const PROPERTY_STATUS_LABELS = { available: 'Disponible', reserved: 'Reservada', sold: 'Vendida' };

export const HERO_STATS = [
  { value: 1200, prefix: '+', label: 'Socios Activos', icon: 'Users' },
  { value: 8500, prefix: '+', label: 'Propiedades Publicadas', icon: 'BarChart3' },
  { value: 50000, prefix: '+', label: 'Contactos Generados', icon: 'Handshake' },
  { value: 9, prefix: '', label: 'Departamentos Representados', icon: 'Map' },
];

export const BENEFITS = [
  {
    icon: 'Users',
    title: 'Red de contactos nacional',
    text: 'Conecta con corredores, empresas e inversionistas en todo Bolivia.',
  },
  {
    icon: 'GraduationCap',
    title: 'Capacitación continua',
    text: 'Accede a cursos, certificaciones y eventos exclusivos.',
  },
  {
    icon: 'BarChart3',
    title: 'Herramientas profesionales',
    text: 'Tecnología, IA, CRM, mapa colaborativo y más para tu negocio.',
  },
  {
    icon: 'ShieldCheck',
    title: 'Credibilidad y respaldo',
    text: 'Forma parte de la institución más representativa del sector inmobiliario.',
  },
  {
    icon: 'Megaphone',
    title: 'Visibilidad y oportunidades',
    text: 'Publica propiedades, genera leads y crece con nuestra comunidad.',
  },
];

export const MODULES = [
  { id: 'feed', title: 'Feed Profesional', description: 'Noticias, consultas, oportunidades y más.', icon: 'Newspaper', color: 'from-blue-500 to-indigo-600', tag: 'Comunidad' },
  { id: 'map', title: 'Mapa Colaborativo', description: 'Propiedades, tendencias, proyectos y eventos en tiempo real.', icon: 'MapPin', color: 'from-emerald-500 to-teal-600', tag: 'Geolocalización' },
  { id: 'ai-chat', title: 'Chat IA Inmobiliario', description: 'Asistente inteligente entrenado en leyes, normativas y más.', icon: 'Bot', color: 'from-purple-500 to-violet-600', tag: 'IA Integrada' },
  { id: 'directory', title: 'Directorio de Socios', description: 'Buscador nacional de corredores y empresas.', icon: 'Users', color: 'from-amber-500 to-orange-600', tag: 'Directorio' },
  { id: 'microsite', title: 'Micrositio Personal', description: 'Tu propia web inmobiliaria profesional.', icon: 'Globe', color: 'from-pink-500 to-rose-600', tag: 'Branding' },
  { id: 'properties', title: 'Mis Propiedades', description: 'Publica y administra tus propiedades de venta o alquiler.', icon: 'Building2', color: 'from-cyan-500 to-blue-600', tag: 'Inventario' },
  { id: 'opportunities', title: 'Oportunidades', description: 'Bolsa de negocios, inversionistas y colaboraciones.', icon: 'Handshake', color: 'from-orange-500 to-red-600', tag: 'Inversión' },
  { id: 'campus', title: 'Campus Virtual', description: 'Cursos, certificaciones y capacitaciones exclusivas.', icon: 'GraduationCap', color: 'from-indigo-500 to-purple-600', tag: 'Formación' },
  { id: 'legal', title: 'Biblioteca Legal', description: 'Contratos, formatos y documentos listos para usar.', icon: 'FileText', color: 'from-slate-600 to-slate-800', tag: 'Normativa' },
  { id: 'observatory', title: 'Observatorio Inmobiliario', description: 'Indicadores, reportes y análisis del mercado.', icon: 'LineChart', color: 'from-teal-500 to-emerald-700', tag: 'Data' },
];

export const MARQUEE_ITEMS = [
  'CÁMARA INMOBILIARIA SANTA CRUZ',
  'CÁMARA INMOBILIARIA LA PAZ',
  'CÁMARA INMOBILIARIA COCHABAMBA',
  'CÁMARA INMOBILIARIA TARIJA',
  'CÁMARA INMOBILIARIA CHUQUISACA',
  'CÁMARA INMOBILIARIA BENI',
  'CÁMARA INMOBILIARIA ORURO',
  'CÁMARA INMOBILIARIA POTOSÍ',
  'CÁMARA INMOBILIARIA PANDO',
];

export const DEPARTMENTS = [
  'La Paz',
  'Santa Cruz',
  'Cochabamba',
  'Chuquisaca',
  'Tarija',
  'Oruro',
  'Potosí',
  'Beni',
  'Pando',
];

export const PROFESSIONAL_TYPES = [
  'Agente Inmobiliario Independiente',
  'Agencia / Inmobiliaria',
  'Constructora / Desarrolladora',
  'Corredor de Bienes Raíces',
  'Profesional Afín (Legal, Avalúos, Arquitectura)',
];

export const MEMBERSHIP_PLANS = [
  {
    name: 'Agente Independiente',
    tagline: 'Para profesionales que inician',
    features: ['Credencial digital QR', 'Feed profesional y directorio', 'Micrositio personal', 'Biblioteca legal', 'Descuentos en Campus CNIB'],
    featured: false,
  },
  {
    name: 'Agencia / Inmobiliaria',
    tagline: 'Para equipos que quieren crecer',
    features: ['Todo lo del plan Agente', 'Hasta 5 usuarios de equipo', 'Mapa colaborativo y MLS', 'CRM y gestión de leads', 'Prioridad en eventos CNIB'],
    featured: true,
  },
  {
    name: 'Constructora / Empresa',
    tagline: 'Para desarrolladoras y corporativos',
    features: ['Todo lo del plan Agencia', 'Usuarios ilimitados', 'Vitrina de proyectos destacada', 'Acceso al Observatorio', 'Convenios y auspicio en congresos'],
    featured: false,
  },
];

export const COURSES = [
  { title: 'Diplomado en Corretaje Inmobiliario Profesional', duration: '6 meses', modality: 'Virtual + presencial', level: 'Certificación CNIB' },
  { title: 'Valuación y Tasación de Inmuebles', duration: '8 semanas', modality: 'Virtual en vivo', level: 'Intermedio' },
  { title: 'Legislación Inmobiliaria Boliviana', duration: '6 semanas', modality: 'Virtual', level: 'Todos los niveles' },
  { title: 'Marketing Digital para Bienes Raíces', duration: '4 semanas', modality: 'Virtual', level: 'Inicial' },
];

export const CONTACT_INFO = {
  address: 'Calle 6 Este, Equipetrol — Santa Cruz de la Sierra, Bolivia',
  phone: '+591 3 344 4000',
  email: 'info@cnib.bo',
  web: 'www.cnib.bo',
};
